import React from "react";
import { Button, Select } from "antd";
import { FilterOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { SUBGROUP_FILTERS, hasActiveFilters } from "../../constants/subgroup-filters";
import { storeSetSubgroupFilters } from "../../store/data-reducer";
import { SubgroupBarWrapper } from "./styled";

// Second header row on the Statistics screen: one select per subgroup filter
const SubgroupFilterBar = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const filters = useSelector((state) => state?.data?.subgroupFilters) || {};
  const active = hasActiveFilters(filters);

  const setFilter = (key, value) => {
    const next = { ...filters };
    if (!value || value === "all") {
      delete next[key];
    } else {
      next[key] = value;
    }
    dispatch(storeSetSubgroupFilters(next));
  };

  return (
    <SubgroupBarWrapper data-testid="subgroup-filter-bar">
      <span className="title">
        <FilterOutlined /> {t("subgroup.title")}
      </span>
      {SUBGROUP_FILTERS.map((filter) => (
        <label key={filter.key} className="item">
          <span>{t(filter.label)}:</span>
          <Select
            className="select-subgroup"
            aria-label={t(filter.label)}
            value={filters[filter.key] || "all"}
            onChange={(value) => setFilter(filter.key, value)}
            options={[
              { value: "all", label: t("subgroup.all") },
              ...filter.values.map((v) => ({ value: v.value, label: t(v.label) })),
            ]}
          />
        </label>
      ))}
      <Button size="small" disabled={!active} onClick={() => dispatch(storeSetSubgroupFilters({}))}>
        {t("subgroup.reset")}
      </Button>
    </SubgroupBarWrapper>
  );
};

export default SubgroupFilterBar;
